import { render, staticRenderFns } from "./LuckyDraw.vue?vue&type=template&id=a8429a20&"
import script from "./LuckyDraw.vue?vue&type=script&lang=js&"
export * from "./LuckyDraw.vue?vue&type=script&lang=js&"
import style0 from "./LuckyDraw.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports